export class PageableResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  currentPage:number;

  constructor(page: any) {
    this.content = page.content || [];
    this.totalElements = page.totalElements || 0;
    this.totalPages = page.totalPages || 0;
    this.size = page.size || 10;
    this.number = page.number || 0;
    this.currentPage=page.currentPage;
  }
}
